<template>
  <div>
    <div class="inputFullName" :class="{ isPc: !isSp }">
      <InputLabel
        class="labelArea"
        :class="{ isPc: !isSp, isHasLabel: !isSp && required, styleLabelWide: styleLabelWide, isPcModal: isPcModal }"
        :required="required"
      >
        {{ areaLabel }}
      </InputLabel>
      <div class="inputsArea" :class="{ isFormCompanionPC: !isSp && isFormCompanion }">
        <InputItem
          :id="idSei"
          :input-value="nameObject.sei"
          class="inputItem"
          input-type="text"
          :placeholder-value="placeholder.sei"
          :class="{ hasError: hasErrorSei, isPc: !isSp, smallInput: smallInput }"
          :disabled="lastNameDisabled"
          @blur="onBlurSei"
          @change="onChangeSei"
          @focus="onFocusSei"
        />
        <InputItem
          :id="idMei"
          :input-value="nameObject.mei"
          class="inputItem"
          input-type="text"
          :placeholder-value="placeholder.mei"
          :class="{ hasError: hasErrorMei, isPc: !isSp, smallInput: smallInput }"
          :disabled="firstNameDisabled"
          @blur="onBlurMei"
          @change="onChangeMei"
          @focus="onFocusMei"
        />
      </div>
    </div>
    <div
      class="underInputArea"
      :class="{
        isPc: !isSp,
        isNoLabelInPc: !isSp && !required,
        styleLabelWide: styleLabelWide,
        isFormCompanion: isFormCompanion,
      }"
    >
      <PartialErrorMessage :is-sp-flg="true" :error="displayErrorSei" class="partialErrorComponent" />
      <PartialErrorMessage
        :is-sp-flg="true"
        :error="displayErrorMei"
        :class="{ hasTwoError: hasErrorSei }"
        class="partialErrorComponent"
      />
    </div>
  </div>
</template>

<script>
import InputLabel from '../Text/InputLabel.vue';
import InputItem from './InputItem.vue';
import PartialErrorMessage from '../PartialErrorMessage.vue';
import {
  isDependentCharacter,
  isAllHiragana,
  checkWordCount,
  isAllKatakana,
  checkCharCode,
  isEmpty,
  checkCompanionCharCode,
} from '../../../../helper/_validationCheck';
import { GENERAL_VALIDATION_MESSAGE, generateWordCountError } from '../../../../helper/_validationCheckMessages';

export const FULL_NAME_TYPE = {
  KANJI: 'kanji',
  HIRAGANA: 'hiragana',
  KATAKANA: 'katakana',
};

export default {
  name: 'InputFullName',
  components: {
    InputLabel,
    InputItem,
    PartialErrorMessage,
  },
  props: {
    areaLabel: {
      type: String,
      required: true,
    },
    nameInputType: {
      required: false,
      default: FULL_NAME_TYPE.KANJI,
      validator(value) {
        return Object.values(FULL_NAME_TYPE).indexOf(value) !== -1;
      },
    },
    /**
     * 外部からのエラー
     * このコンポーネントに定義しないような独自のバリデーションを持つ場合、
     * 親コンポーネントでv-modelの値をwatchとかしてバリデーションチェックを行い、
     * errorFromOuterにpropsで渡すと、最後の項目としてチェック入る。
     * 空文字・undefinedを渡すことで『エラー無し』扱いになる。
     */
    errorFromOuterSei: {
      type: String,
      required: false,
      default: '',
    },
    errorFromOuterMei: {
      type: String,
      required: false,
      default: '',
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    smallInput: {
      type: Boolean,
      required: false,
      default: false,
    },
    styleLabelWide: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    /**
     * 初期値を設定したい場合に、以下のnameObjectに初期値を渡す
     */
    nameObject: {
      type: Object,
      required: false,
      default: () => ({
        sei: '',
        mei: '',
      }),
    },
    lastNameDisabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    firstNameDisabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    /**
     * 資料請求確認画面PC、 予約確認画面PCの時のみtrue
     * 両画面の変更フォームをモーダル内に表示する際にスタイル調整するため。
     */
    isPcModal: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    /**
     * 任意項目の場合trueで渡ってくる
     * 姓、名未入力バリデーションを発生させないため
     */
    isOptional: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    /**
     * 見学会予約確認画面の同行者フォームの場合true
     */
    isFormCompanion: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    /**
     * 苗字インプットにidセット
     */
    idSei: {
      type: String,
      required: false,
      default: undefined,
    },
    /**
     * 名インプットにidセット
     */
    idMei: {
      type: String,
      required: false,
      default: undefined,
    },
    /**
     * マウント時にバリデーションをする
     */
    validateAtMount: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * trueの場合watchでsei、meiを監視し変更があった場合emitで更新値を渡す＆バリデーションを走らせる
     */
    watchNameObjectFlg: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * trueの場合sei、meiにバリデーションを走らせる
     */
    updateFuriganaFlg: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      validationErrorSei: undefined,
      validationErrorMei: undefined,
      sei: this.nameObject.sei,
      mei: this.nameObject.mei,
    };
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
    placeholder() {
      if (this.nameInputType === FULL_NAME_TYPE.KANJI) {
        return {
          sei: '姓',
          mei: '名',
        };
      }
      if (this.nameInputType === FULL_NAME_TYPE.KATAKANA) {
        return {
          sei: 'セイ',
          mei: 'メイ',
        };
      }
      return {
        sei: 'せい',
        mei: 'めい',
      };
    },
    displayErrorSei() {
      if (this.validationErrorSei) return this.validationErrorSei;
      return this.errorFromOuterSei;
    },
    displayErrorMei() {
      if (this.validationErrorMei) return this.validationErrorMei;
      return this.errorFromOuterMei;
    },
    hasErrorSei() {
      // displayError自体がundefinedならエラーない
      if (!this.displayErrorSei) return false;
      // displayError自体がlengthもってるならエラーあり
      if (this.displayErrorSei.length) return true;
      return false;
    },
    hasErrorMei() {
      // displayError自体がundefinedならエラーない
      if (!this.displayErrorMei) return false;
      // displayError自体がlengthもってるならエラーあり
      if (this.displayErrorMei.length) return true;
      return false;
    },
  },
  watch: {
    nameObject: {
      handler(newValue) {
        if (!this.watchNameObjectFlg) return;
        this.sei = newValue.sei;
        this.mei = newValue.mei;
        this.$emit('changeNameObject', {
          sei: this.sei,
          mei: this.mei,
        });
        this.onBlurSei();
        this.onBlurMei();
      },
      deep: true,
    },
    updateFuriganaFlg() {
      this.onBlurSei();
      this.onBlurMei();
    },
  },
  mounted() {
    if (this.validateAtMount) {
      this.onBlurSei();
      this.onBlurMei();
    }
  },
  methods: {
    async onBlurSei() {
      this.validationErrorSei = await this.validationCheck(this.sei, this.errorFromOuterSei, this.placeholder.sei);
      this.$emit('watchValidationSei', !!this.validationErrorSei);
      this.$emit('blurSei');
    },
    async onBlurMei() {
      this.validationErrorMei = await this.validationCheck(this.mei, this.errorFromOuterMei, this.placeholder.mei);
      this.$emit('watchValidationMei', !!this.validationErrorMei);
      this.$emit('blurMei');
    },
    async validationCheck(value, errorFromOuter, inputAreaCategory) {
      if (!this.isOptional && isEmpty(value)) {
        return inputAreaCategory + GENERAL_VALIDATION_MESSAGE.EMPTY;
      }
      if (this.nameInputType === FULL_NAME_TYPE.KANJI) {
        const min = '1';
        const max = '20';
        // 任意項目の場合、空であってもエラー文言は返さない
        if (this.isOptional && isEmpty(value)) {
          return undefined;
        }
        if (!checkWordCount(value, min, max)) {
          return generateWordCountError(inputAreaCategory, undefined, max);
        }
      }
      if (this.nameInputType === FULL_NAME_TYPE.KATAKANA) {
        const min = '1';
        const max = '30';
        if (!checkWordCount(value, min, max)) {
          return generateWordCountError(inputAreaCategory, undefined, max);
        }
        if (!isAllKatakana(value)) {
          return inputAreaCategory + GENERAL_VALIDATION_MESSAGE.NOT_KATAKANA_ERROR;
        }
      }
      if (this.nameInputType === FULL_NAME_TYPE.HIRAGANA) {
        const min = '1';
        const max = '30';
        if (!checkWordCount(value, min, max)) {
          return generateWordCountError(inputAreaCategory, undefined, max);
        }
        if (!isAllHiragana(value)) {
          return inputAreaCategory + GENERAL_VALIDATION_MESSAGE.NOT_HIRAGANA_ERROR;
        }
      }
      if (isDependentCharacter(value) && !this.isFormCompanion) {
        return inputAreaCategory + GENERAL_VALIDATION_MESSAGE.DEPENDENT_CHARACTER;
      }
      // 同行者フォームの場合のみcheckCompanionCharCodeでバリデーションチェックする。通常はcheckCharCodeで判断する
      if (this.isFormCompanion && (await checkCompanionCharCode(value)) === 1) {
        return inputAreaCategory + GENERAL_VALIDATION_MESSAGE.INVALID_CHAR_ERROR;
      }
      if (!this.isFormCompanion && (await checkCharCode(value)) === 1) {
        return inputAreaCategory + GENERAL_VALIDATION_MESSAGE.INVALID_CHAR_ERROR;
      }
      if (errorFromOuter) {
        return this.errorFromOuter;
      }
      return undefined;
    },
    onChangeSei(value) {
      this.sei = value;
      this.$emit('change', {
        sei: this.sei,
        mei: this.mei,
      });
    },
    onChangeMei(value) {
      this.mei = value;
      this.$emit('change', {
        sei: this.sei,
        mei: this.mei,
      });
    },
    onFocusSei() {
      this.$emit('focusSei');
    },
    onFocusMei() {
      this.$emit('focusMei');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

$label-width-pc: 120px;
$label-width-pc-wide: 124px;
$label-width-has-label-pc: 184px;

.inputFullName {
  .labelArea.isPc {
    width: $label-width-pc;
    margin: auto 0;

    &.styleLabelWide {
      width: $label-width-pc-wide;
    }

    &.isHasLabel {
      width: $label-width-has-label-pc;
    }

    &.isPcModal {
      width: 32px;
    }
  }

  &.isPc {
    display: flex;
  }
}

.underInputArea {
  margin-top: 8px;

  &.isPc {
    margin-left: $label-width-has-label-pc;

    &.isNoLabelInPc {
      margin-left: $label-width-pc;
    }

    &.styleLabelWide {
      margin-left: $label-width-pc-wide;
    }

    &.isFormCompanion {
      margin-left: 32px;
    }
  }

  .partialErrorComponent {
    &.hasTwoError {
      margin-top: 4px;
    }
  }
}

.inputsArea {
  display: flex;

  &.isFormCompanionPC {
    width: 396px;
  }

  .inputItem {
    margin-left: 8px;

    &:first-child {
      margin-left: 0;
    }

    &.isPc {
      width: 212px;
    }

    &.smallInput {
      width: 154px;
    }
  }

  .hasError,
  .hasError:focus {
    border: $border-alert;
  }
}
</style>
